<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批</el-breadcrumb-item>
      <el-breadcrumb-item>创建机构</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.spstatus" placeholder="请选择审批状态" style="width: 100%">
              <el-option label="请选择审批状态" value="-1"></el-option>
              <el-option label="审批不通过" value="0"></el-option>
              <el-option label="待副总经理审核" value="1"></el-option>
              <el-option label="待系统管理员操作" value="2"></el-option>
              <el-option label="已完成" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.modifystatus" placeholder="请选择变更状态" style="width: 100%">
              <el-option label="请选择变更状态" value="-1"></el-option>
              <el-option label="无需修改" value="0"></el-option>
              <el-option label="待副总经理审核" value="1"></el-option>
              <el-option label="待系统管理员操作" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.jigouname" @keyup.enter.native="clicksearch" placeholder="请输入机构名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.username" @keyup.enter.native="clicksearch" placeholder="请输入提现姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入提现号码" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="创建时间(开始)" class="mr15"></el-date-picker>
            <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="创建时间(结束)" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Spstatusname" label="审批状态" min-width="5%"></el-table-column>
          <el-table-column prop="Modifystatusname" label="变更状态" min-width="5%"></el-table-column>
          <el-table-column prop="Parentname" label="上级名称" min-width="10%"></el-table-column>
          <el-table-column prop="Jigouname" label="机构名称" min-width="10%"></el-table-column>
          <el-table-column prop="Rolename" label="权限角色" min-width="5%"></el-table-column>
          <el-table-column prop="Phone" label="提现手机" min-width="10%"></el-table-column>
          <el-table-column prop="Username" label="提现姓名" min-width="5%"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" min-width="22%"></el-table-column>
          <el-table-column prop="Name1" label="经办人" min-width="5%"></el-table-column>
          <el-table-column prop="Name2" label="副总经理" min-width="5%"></el-table-column>
          <el-table-column prop="Name3" label="系统管理员" min-width="5%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Spstatus == 0 && SubRule_ShenPiJiGou_Delete" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Spstatus <= 1 && SubRule_ShenPiJiGou_Add" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickEdit(scope.row)">修改</el-button>
              <el-button v-if="scope.row.Spstatus == 1 && SubRule_ShenPiJiGou_FuZong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1(scope.row)">副总经理审核</el-button>
              <el-button v-if="scope.row.Spstatus == 2 && SubRule_ShenPiJiGou_Admin" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe2(scope.row)">系统管理员操作</el-button>
              <el-button v-if="scope.row.Spstatus == 3" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goModify(scope.row)">申请变更</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <el-dialog
          title="审批"
          :visible.sync="dialogVisible"
          width="20%">
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="ShenHeOK">同意</el-button>
            <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
          </span>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="申请创建机构" name="second" v-if="SubRule_ShenPiJiGou_Add">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">上级机构(必选)</span>
          </label>
          <Rsljigou :propsjigouid="addForm.parentid" :propsjigouname="addForm.parentname" @change="changeRsljigou"></Rsljigou>
        </el-form-item>
        <el-form-item class="addAdminFormLong">
          <label slot="label">
            <span style="color: #FF0000;">归属区域(必选)</span>
          </label>
          <el-select v-model="addForm.province" placeholder="请选择省" class="select1" @change="changeprovince">
            <el-option
              v-for="item in optionsprovince" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="addForm.city" collapse-tags  class="select1" placeholder="请选择市" @change="changecity">
            <el-option
              v-for="item in optionscity" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="addForm.town" collapse-tags  class="select1" placeholder="请选择区" style="margin: 0">
            <el-option
              v-for="item in optionsarea" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">机构名称(必填)</span>
          </label>
          <el-input v-model="addForm.jigouname"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">权限角色(必选)</span>
          </label>
          <el-select v-model="addForm.roleid" placeholder="请选择" style="width: 100%">
            <el-option label="运营商店员权限" value="3"></el-option>
            <el-option label="运营商店员权限+设备归属" value="36"></el-option>
            <el-option label="运营商店员权限+微盘" value="34"></el-option>
            <el-option label="运营商采购权限" value="5"></el-option>
            <el-option label="运营商老板权限" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">是否开通提现(必选)</span>
          </label>
          <el-select v-model="addForm.tixian" placeholder="请选择" style="width: 100%">
            <el-option label="不开通提现账号" value="0"></el-option>
            <el-option label="开通提现账号" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提现账号姓名" class="addAdminForm" v-if="addForm.tixian == 1">
          <el-input v-model="addForm.username"></el-input>
        </el-form-item>
        <el-form-item label="提现账号手机" class="addAdminForm" v-if="addForm.tixian == 1">
          <el-input v-model="addForm.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <el-tab-pane label="修改" name="three" disabled="disabled">
      <ShenPiJiGouEdit ref="SubVuethree" v-on:triggerFunc="BackToFirst"></ShenPiJiGouEdit>
    </el-tab-pane>

    <el-tab-pane label="变更" name="four" disabled="disabled">
      <ShenPiJiGouModify ref="SubVuefour" v-on:triggerFunc="BackToFirst"></ShenPiJiGouModify>
    </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import ShenPiJiGouEdit from '@/componentsSubVue/ShenPiJiGouEdit.vue'
import ShenPiJiGouModify from '@/componentsSubVue/ShenPiJiGouModify.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    ShenPiJiGouEdit,
    ShenPiJiGouModify
  },
  name: 'MyShenPiJiGou',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        parentid: '',
        parentname: '',
        province: '',
        city: '',
        town: '',
        jigouname: '',
        roleid: '3',
        phone: '',
        username: '',
        tixian: '0'
      },
      timer: '',
      // 查询
      keywords: {
        spstatus: '-1',
        modifystatus: '-1',
        jigouname: '',
        username: '',
        phone: '',
        begintime: '',
        endtime: ''
      },
      optionsprovince: [],
      optionscity: [],
      optionsarea: [],
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogVisible: false,
      apiShenPiJiGouSHUrl: '',
      spid: 0,
      SubRule_ShenPiJiGou_Add: false,
      SubRule_ShenPiJiGou_Delete: false,
      SubRule_ShenPiJiGou_FuZong: false,
      SubRule_ShenPiJiGou_Admin: false
    }
  },
  mounted () {
    this.apiGetShenPiJiGouNum()
    this.apiGetShenPiJiGouList()
    this.apigetregionlist(1, 1)

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiJiGou_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiJiGou_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiJiGou_Delete', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiJiGou_Delete = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiJiGou_FuZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiJiGou_FuZong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiJiGou_Admin', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiJiGou_Admin = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetShenPiJiGouList()
    },
    changeRsljigou (vid, vname) {
      this.addForm.parentid = vid
      this.addForm.parentname = vname
    },
    changeprovince (data) {
      this.apigetregionlist(2, data)
    },
    changecity (data) {
      this.apigetregionlist(3, data)
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    clickadd () {
      this.apiAddShenPiJiGou()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    ShenHe1 (row) {
      this.dialogVisible = true
      this.apiShenPiJiGouSHUrl = Vue.prototype.global.Url_ShenPiJiGouSH1
      this.spid = row.Id
    },
    ShenHe2 (row) {
      this.dialogVisible = true
      this.apiShenPiJiGouSHUrl = Vue.prototype.global.Url_ShenPiJiGouSH2
      this.spid = row.Id
    },
    ShenHeOK () {
      this.dialogVisible = false
      this.apiShenPiJiGouSH(1)
    },
    ShenHeNO () {
      this.dialogVisible = false
      this.apiShenPiJiGouSH(-1)
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiJiGou(row.Id)
      })
    },
    clickEdit (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    goModify (row) {
      this.activeName = 'four'
      this.$refs.SubVuefour.LoadData(row)
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetShenPiJiGouNum()
      this.apiGetShenPiJiGouList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetShenPiJiGouList()
    },
    apigetregionlist: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: parentid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getregionlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            if (type == 1) {
              that.optionsprovince = []
              response.data.List.filter((item, i) => {
                that.optionsprovince.push({ value: item.Id, label: item.Name })
              })
            }
            if (type == 2) {
              that.optionscity = []
              response.data.List.filter((item, i) => {
                that.optionscity.push({ value: item.Id, label: item.Name })
              })
            }
            if (type == 3) {
              that.optionsarea = []
              response.data.List.filter((item, i) => {
                that.optionsarea.push({ value: item.Id, label: item.Name })
              })
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiJiGouNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spstatus: that.keywords.spstatus,
        modifystatus: that.keywords.modifystatus,
        jigouname: that.keywords.jigouname,
        username: that.keywords.username,
        phone: that.keywords.phone,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiJiGouNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiJiGouList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        spstatus: that.keywords.spstatus,
        modifystatus: that.keywords.modifystatus,
        jigouname: that.keywords.jigouname,
        username: that.keywords.username,
        phone: that.keywords.phone,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiJiGouList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiJiGou: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000

      if (that.addForm.tixian == '0') {
        that.addForm.username = ''
        that.addForm.phone = ''
      }
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: that.addForm.parentid,
        province: that.addForm.province,
        city: that.addForm.city,
        town: that.addForm.town,
        jigouname: that.addForm.jigouname,
        roleid: that.addForm.roleid,
        username: that.addForm.username,
        phone: that.addForm.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiJiGou, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiJiGouNum()
            that.apiGetShenPiJiGouList()

            // 清空添加
            that.addForm.parentid = ''
            that.addForm.parentname = ''
            that.addForm.province = ''
            that.addForm.city = ''
            that.addForm.town = ''
            that.addForm.jigouname = ''
            that.addForm.roleid = '3'
            that.addForm.phone = ''
            that.addForm.username = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelShenPiJiGou: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelShenPiJiGou, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiJiGouNum()
            that.apiGetShenPiJiGouList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiJiGouSH: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: that.spid,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiJiGouSHUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiJiGouNum()
            that.apiGetShenPiJiGouList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}
.select1{
    width: 113px;
    margin-right: 15px;
}
/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
/deep/ .el-table .cell {
  white-space: pre-line;
}
</style>
